import { React, ts, useSelector } from '_core';

import Chart from './chart';
import Form from './form';
import { DraftParams, Params } from './types';

type PredictedAndRealizedRiskVsTimeProps = {
  id: string;
  readOnly: boolean;
  widgetKey: string;
  mode: ts.enums.CHART_MODE_ENUM;
  params: Params | DraftParams;
  setParams: (_p: Params) => void;

  fullScreen?: boolean;
  loadWidgetData: (_payload: ts.types.widgets.WidgetGetDataParams) => Promise<ts.types.widgets.WidgetGetDataResponse>;
  widgetPaths?: Record<'realized_predicted_risk', string>;

  title: string;

  context: ts.types.riskModel.RiskModelAnalysisContext;
};

const PredictedAndRealizedRiskVsTime = ({
  id,
  readOnly,
  widgetKey,
  mode,
  params,
  setParams,
  loadWidgetData,
  widgetPaths,
  fullScreen,
  title,
  context,
}: PredictedAndRealizedRiskVsTimeProps) => {
  const riskModels = useSelector((state) => state.resources.risk_models);

  const riskModel = React.useMemo(() => {
    return riskModels.find((rm) => rm.id === context.risk_model_id);
  }, [riskModels, context]);

  const renderJobComponent = () => (
    <Chart
      id={id}
      readOnly={readOnly}
      widgetKey={widgetKey}
      loadWidgetData={loadWidgetData}
      file={widgetPaths['realized_predicted_risk']}
      fullScreen={fullScreen}
      title={title}
      riskModel={riskModel}
    />
  );

  return <>{mode == 'edit' ? <Form params={params} setParams={setParams} /> : renderJobComponent()}</>;
};

export default PredictedAndRealizedRiskVsTime;
